import { render, staticRenderFns } from "./linkem-radio.vue?vue&type=template&id=dea3fd0a&"
import script from "./linkem-radio.vue?vue&type=script&lang=js&"
export * from "./linkem-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports